var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});

function default_1(number, index) {
  return [["justo ahora", "en un rato"], ["hace %s segundos", "en %s segundos"], ["hace 1 minuto", "en 1 minuto"], ["hace %s minutos", "en %s minutos"], ["hace 1 hora", "en 1 hora"], ["hace %s horas", "en %s horas"], ["hace 1 d\xEDa", "en 1 d\xEDa"], ["hace %s d\xEDas", "en %s d\xEDas"], ["hace 1 semana", "en 1 semana"], ["hace %s semanas", "en %s semanas"], ["hace 1 mes", "en 1 mes"], ["hace %s meses", "en %s meses"], ["hace 1 a\xF1o", "en 1 a\xF1o"], ["hace %s a\xF1os", "en %s a\xF1os"]][index];
}

exports.default = default_1; //# sourceMappingURL=es.js.map

export default exports;
export const __esModule = exports.__esModule;